import React, { useState } from 'react';
import { renderToString } from 'react-dom/server';
import PropTypes from 'prop-types';

import { APIHandler, SharingPopup, DataHandler } from 'C4';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import buttonData from './buttonData';

const slideshowTypes = ['slideshow'];

const defaultFancyboxOptions = (link) =>
  JSON.stringify({
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(<SharingPopup url={link} />),
    },
  });

const parseUrl = (template, { url, appId, name }) => {
  if (!template) return url;
  if (slideshowTypes.includes(name)) return '';

  const variables = {
    contentUrl: appContentUrl,
    appId,
    file: url,
  };

  let href = template;
  Object.keys(variables).forEach((k) => {
    href = href.replace(new RegExp(`{${k}}`, 'g'), variables[k]);
  });
  return href.replace(/\/\//g, '/').replace(/https:\//g, 'https://');
};

const Button = ({ altIcon, fancybox, icon, name, onClick, target, type, url, urlTemplates }) => {
  const appId = DataHandler.matchAppId();

  let parsedIcon = icon;
  if (altIcon) {
    const [newIcon] = Object.keys(altIcon).filter((k) => url.includes(k));
    if (newIcon) parsedIcon = altIcon[newIcon];
  }

  const key = appId > 500 ? 'new' : 'old';
  const href = parseUrl(urlTemplates[key], { url: url.split(','), appId });
  console.log(href);
  const props = {
    href,
    id: `${name}-${url}`,
    onClick,
    ...(fancybox && {
      'data-fancybox': url,
      'data-type': type,
    }),
    ...(target && {
      target,
      rel: 'noopener noreferrer',
    }),
  };

  if (fancybox) props['data-options'] = defaultFancyboxOptions(...href);

  return (
    <a {...props}>
      <button type="button" className="linkButton">
        <FontAwesomeIcon icon={parsedIcon} />
      </button>
    </a>
  );
};

const SlideShow = ({ links = [], data }) => (
  <div className="hidden_images">
    {links.map((link) => (
      <a
        key={link}
        href={APIHandler.getDownloadURL(link)}
        data-fancybox={data}
        data-options={defaultFancyboxOptions(link)}
      >
        <img src={link} alt={`hidden_${link}`} />
      </a>
    ))}
  </div>
);

const HiddenMedia = ({ link, data }) => (
  <div className="hidden_single_media">
    <div id={link} href={link} data-fancybox={data} data-options={defaultFancyboxOptions(link)} />
  </div>
);

const LinkButton = ({ completed, link, mandatory, type }) => {
  const [isComplete, setComplete] = useState(false);

  const parsedType = type.replace(/[0-9]/g, '');
  const data = buttonData[parsedType];

  const [url, ...rest] = link.split(',');

  return (
    <div className="linkButton__container">
      <Button
        {...data}
        url={url}
        name={parsedType}
        onClick={() => {
          if (!isComplete && mandatory) {
            setComplete(true);
            completed();
          }
        }}
      />

      {slideshowTypes.includes(parsedType) && <SlideShow links={rest} data={data.fancybox} />}

      {data.fancybox && data.fancybox.includes('single_media') && <HiddenMedia link={url} fancybox={data.fancybox} />}
    </div>
  );
};

export default LinkButton;

SlideShow.propTypes = {
  links: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.string,
};

SlideShow.defaultProps = {
  links: [],
  data: null,
};

HiddenMedia.propTypes = {
  link: PropTypes.string,
  data: PropTypes.string,
};

HiddenMedia.defaultProps = {
  link: null,
  data: null,
};

Button.propTypes = {
  altIcon: PropTypes.shape(),
  fancybox: PropTypes.string,
  icon: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
  urlTemplates: PropTypes.shape(),
};

Button.defaultProps = {
  altIcon: {},
  fancybox: null,
  icon: ['fas', 'question'],
  name: null,
  onClick: () => {},
  target: '_blank',
  type: null,
  url: null,
  urlTemplates: {},
};

LinkButton.propTypes = {
  completed: PropTypes.func.isRequired,
  link: PropTypes.string,
  mandatory: PropTypes.bool,
  type: PropTypes.string,
};

LinkButton.defaultProps = {
  link: null,
  mandatory: true,
  type: null,
};
